module.exports = __webpack_public_path__ + "assets/d3db7c70f53739b1bd00116489f28463.svg";